import { Badge, Box, HStack, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { FiGlobe } from "react-icons/fi";

interface DomainSelectionProps {
  domain: string;
  onChange: (domain: string) => void;
  disabled?: boolean;
}

export const DomainSelection: React.FC<DomainSelectionProps> = ({
  domain,
  onChange,
  disabled = false
}) => {
  return (
    <Box bg="white" shadow="sm" rounded="lg" p={6}>
      <HStack mb={4}>
        <Icon as={FiGlobe} color="blue.500" boxSize={5} />
        <Text fontWeight="semibold" fontSize="lg">
          Select Domain
        </Text>
        <Badge colorScheme="red" size="sm">
          Required
        </Badge>
      </HStack>
      <Box>
        <Text fontSize="sm" fontWeight="medium" mb={2}>
          Tracking Domain
        </Text>
        <select
          value={domain}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          style={{
            width: "100%",
            padding: "0.75rem",
            fontSize: "1rem",
            borderRadius: "0.375rem",
            border: "1px solid #CBD5E0",
            backgroundColor: "white"
          }}
        >
          <option value="try.zown.ca">try.zown.ca</option>
          <option value="go.zown.ca">go.zown.ca</option>
          <option value="link.zown.ca">link.zown.ca</option>
          <option value="track.zown.ca">track.zown.ca</option>
          <option value="try.zownhomes.com">try.zownhomes.com</option>
          <option value="go.zownhomes.com">go.zownhomes.com</option>
          <option value="get.zownhomes.com">get.zownhomes.com</option>
          <option value="start.zownhomes.com">start.zownhomes.com</option>
          <option value="visit.zownhomes.com">visit.zownhomes.com</option>
          <option value="click.zownhomes.com">click.zownhomes.com</option>
        </select>
        <Text fontSize="sm" color="gray.500" mt={2}>
          Select the domain for your tracking link
        </Text>
      </Box>
    </Box>
  );
};
